/**
 * @generated SignedSource<<74098352202115bd05c86d96521a4bd3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductInfoExpanded_StoreProduct$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsComponent_ProductDetails" | "ProductHeader_ProductDetails">;
  readonly " $fragmentType": "ProductInfoExpanded_StoreProduct";
};
export type ProductInfoExpanded_StoreProduct$key = {
  readonly " $data"?: ProductInfoExpanded_StoreProduct$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductInfoExpanded_StoreProduct">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductInfoExpanded_StoreProduct",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductHeader_ProductDetails"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductDetailsComponent_ProductDetails"
    }
  ],
  "type": "StoreProduct",
  "abstractKey": null
};

(node as any).hash = "b28e26302dfab4d6f8cfb28500ad7d5c";

export default node;
